module.exports = __webpack_public_path__ + "static/media/profile3.8464b18a.png";